import { canAccessFeature } from '@/utils/access';

export const DEFAULT_SECTION_TAB = 'Overview';

export function sectionHasRoleAccess(section, tenantRoles) {
  if (section.required_feature && !canAccessFeature(section.required_feature)) {
    return false;
  }
  if (!Array.isArray(section.visible_roles) || section.visible_roles.length === 0) {
    return true;
  }
  const userRoles = tenantRoles || [];
  return section.visible_roles.some((role) => userRoles.includes(role));
}

export function visibleSections(layoutConfig, tenantRoles) {
  if (!layoutConfig?.sections) return [];
  return layoutConfig.sections
    .filter((s) => s.visible !== false && sectionHasRoleAccess(s, tenantRoles))
    .sort((a, b) => (a.order ?? 999) - (b.order ?? 999));
}

export function sectionTab(section, defaultTab = DEFAULT_SECTION_TAB) {
  return section.tab || defaultTab;
}
